import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {MatInputModule} from '@angular/material/input';
import {ReactiveFormsModule} from '@angular/forms';
import {InputColorComponent} from './input-color.component';
import {ColorPickerModule} from 'ngx-color-picker';

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        ReactiveFormsModule,
        MatInputModule,
        ColorPickerModule,
    ],
    declarations: [
        InputColorComponent,
    ],
    exports: [
        InputColorComponent,
    ],
})
export class InputColorModule {
}
